import React from 'react'
import { TextField, FormControl, Grid, Button } from '@mui/material'
import { LinearLoading, CustomAutocomplete } from 'common'

export const FilterForm = ({ useFetchInit }) => {

    const {
        Forms,
        FetchData,
        Actions,
    } = useFetchInit

    // ------------------------------------------------ Formularios
    const { FilterForm } = Forms
    const { formState } = FilterForm

    // ------------------------------------------------ FetchData
    const { fetchAllBanks, fetchBankDeposits } = FetchData
    const { banks } = fetchAllBanks
    const { loadingFetchBankDeposits } = fetchBankDeposits

    // ------------------------------------------------ Actions
    const {
        onSubmitFilterForm,
        handleChangeStartDate,
        handleChangeEndDate,
        handleChangeIdbanco,
        handleClickPrintBankReport,
    } = Actions

    return (
        <>
            {loadingFetchBankDeposits && (<LinearLoading />)}

            <form onSubmit={onSubmitFilterForm}>
                <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                        <FormControl fullWidth>
                            <label htmlFor="startDate">* Fecha de inicio</label>
                            <TextField
                                id='startDate'
                                name='startDate'
                                value={formState.startDate}
                                onChange={handleChangeStartDate}
                                size='small'
                                placeholder='Fecha de inicio'
                                type='date'
                                variant='outlined'
                                hiddenLabel
                                InputProps={{ readOnly: false }}
                                required
                            />
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={12} md={4} lg={4}>
                        <FormControl fullWidth>
                            <label htmlFor="endDate">* Fecha fin</label>
                            <TextField
                                id='endDate'
                                name='endDate'
                                value={formState.endDate}
                                onChange={handleChangeEndDate}
                                size='small'
                                placeholder='Fecha de finalización'
                                type='date'
                                variant='outlined'
                                hiddenLabel
                                InputProps={{ readOnly: false }}
                                required
                            />
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={12} md={4} lg={4}>
                        <FormControl fullWidth>
                            <label htmlFor="idbanco">Banco</label>
                            <CustomAutocomplete
                                customId="idbanco"
                                customName="idbanco"
                                customValue={formState.idbanco}
                                customOnChange={(target, value) =>
                                    handleChangeIdbanco({ target: { name: 'idbanco', value: value.value } })
                                }
                                customPlaceholder='Seleccionar banco'
                                customOptions={[
                                    { value: 'ALL', name: 'Todos los bancos' },
                                    ...banks.map(({ idbanco, nombre }) => ({
                                        value: String(idbanco),
                                        name: nombre
                                    }))
                                ]}
                                customDisableClearable={true}
                                customDisabled={false}
                            />
                        </FormControl>
                    </Grid>
                </Grid>

                <div className="pt-4"></div>
                <Grid
                    container
                    justifyContent="center"
                    alignItems="center"
                    spacing={2}
                    direction="row"
                >
                    <Grid item>
                        <Button
                            style={{ background: '#4b4b4c' }}
                            variant="contained"
                            type="submit"
                        >
                            <i className="fas fa-search"></i> &nbsp; Buscar
                        </Button>
                    </Grid>

                    <Grid item>
                        <Button
                            style={{ background: '#4b4b4c' }}
                            variant="contained"
                            type="button"
                            onClick={handleClickPrintBankReport}
                        >
                            <i className="fas fa-print"></i> &nbsp; Imprimir
                        </Button>
                    </Grid>
                </Grid>
            </form >
        </>
    )
}
